import { ScrollReveal } from './ScrollReveal';

export type {
  TypeAnimacion,
  TypeRevealEffect,
  TypeScrollRevealProps,
} from './types';

export default ScrollReveal;
